import {DxObjectMapper} from "../dx-core/services/dx-object-mapper.service";
import {DxNciDictionary} from "../dx-nci-core/domain/dx-nci-dictionary";
import {DxNciDictionaryItem} from "../dx-nci-core/domain/dx-nci-dictionary-item";
import {PitNciRegistryTreeNode} from "./domain/pit-nci-registry-tree-node";
import * as faker from "faker";


/** Провайдер моков для справочников НСИ */
export class PitNciMocksProvider {

  public static provideNciMocks(): Object[] {
    const dictionaries = [];
    dictionaries.push({key: 'PIT_EVENT_TYPE', value: PitNciMocksProvider.providePitEventTypeDictMocks()});
    dictionaries.push({key: 'PIT_FUNDS_ADDITION_TYPE', value: PitNciMocksProvider.providePitFundsAdditionTypeDictMocks()});
    dictionaries.push({key: 'PIT_EVENT_CUSTOMER', value: PitNciMocksProvider.provideEventsCustomersDictMocks()});
    dictionaries.push({key: 'budget-period', value: PitNciMocksProvider.provideBudgetPeriodDictMocks()});
    dictionaries.push({key: 'ris-status-contract', value: PitNciMocksProvider.provideContractStatuses()});
    dictionaries.push({key: 'contractor', value: PitNciMocksProvider.provideContractors()});
    return dictionaries;
  }


  public static providePitEventTypeDictMocks(): Object {
    const dictionary = new DxNciDictionary();
    dictionary.id = 1;
    dictionary.ident = 'PIT_EVENT_TYPE';
    dictionary.name = 'Справочник типов IT-мероприятий';
    dictionary.isHierarchical = false;

    let item = new DxNciDictionaryItem();
    item.id = 1;
    item.ident = 'PIT_ARM_GPRM';
    item.name = 'Разработка IT-ситемы АРМ ГПРМ';
    item.ord = 1;
    dictionary.addItem(item);

    item = new DxNciDictionaryItem();
    item.id = 2;
    item.ident = 'PIT_AG_STI';
    item.name = 'Внедрение системы сбора статисческой информации АГ СТИ';
    item.ord = 2;
    dictionary.addItem(item);

    item = new DxNciDictionaryItem();
    item.id = 3;
    item.ident = 'PIT_AVP_RM';
    item.name = 'Развитие системы электронного документо-оборота АВП РМ';
    item.ord = 3;
    dictionary.addItem(item);

    item = new DxNciDictionaryItem();
    item.id = 4;
    item.ident = 'PIT_EXCLUDE_OUT_OF_DATE';
    item.name = 'Вывод из эксплуатации устаревших систем';
    item.ord = 4;
    dictionary.addItem(item);

    item = new DxNciDictionaryItem();
    item.id = 5;
    item.ident = 'PIT_MES_PK';
    item.name = 'Внедрение системы МЭШ в ПК';
    item.ord = 5;
    dictionary.addItem(item);

    return DxObjectMapper.toPlainJson(dictionary, DxNciDictionary);
  }


  public static providePitFundsAdditionTypeDictMocks(): Object {
    const dictionary = new DxNciDictionary();
    dictionary.id = 1;
    dictionary.ident = 'PIT_FUNDS_ADDITION_TYPE';
    dictionary.name = 'Справочник типов порядка доведения средств';
    dictionary.isHierarchical = false;

    let item = new DxNciDictionaryItem();
    item.id = 1;
    item.ident = 'PIT_GP_ARM_BR';
    item.name = 'Государственная программа Пермского края "Качественное здравоохранение"';
    item.ord = 1;
    dictionary.addItem(item);

    item = new DxNciDictionaryItem();
    item.id = 2;
    item.ident = 'PIT_GP_IS_BP';
    item.name = 'Государственная программа Пермского края "Образование и молодежная политика"';
    item.ord = 2;
    dictionary.addItem(item);

    item = new DxNciDictionaryItem();
    item.id = 3;
    item.ident = 'PIT_GP_VAP_NG';
    item.name = 'Государственная программа Пермского края "Социальная поддержка жителей Пермского края"';
    item.ord = 3;
    dictionary.addItem(item);

    item = new DxNciDictionaryItem();
    item.id = 4;
    item.ident = 'PIT_GP_SAPR_VG';
    item.name = 'ГП Внедрение САПР ВГ';
    item.ord = 4;
    dictionary.addItem(item);

    item = new DxNciDictionaryItem();
    item.id = 5;
    item.ident = 'PIT_GP_APR_TR';
    item.name = 'ГП Развитие АПР ТР';
    item.ord = 5;
    dictionary.addItem(item);

    item = new DxNciDictionaryItem();
    item.id = 6;
    item.ident = 'PIT_GP_ORP_SR';
    item.name = 'ГП Сопровождение ОРП СР';
    item.ord = 6;
    dictionary.addItem(item);

    item = new DxNciDictionaryItem();
    item.id = 7;
    item.ident = 'PIT_GP_APR_PV';
    item.name = 'ГП Выведение из экплуатаци АПР ПВ';
    item.ord = 7;
    dictionary.addItem(item);

    item = new DxNciDictionaryItem();
    item.id = 8;
    item.ident = 'PIT_GP_EGG_SPR';
    item.name = 'ГП Внедрение ЕГГ СПР';
    item.ord = 8;
    dictionary.addItem(item);

    item = new DxNciDictionaryItem();
    item.id = 9;
    item.ident = 'PIT_GP_APR_AP';
    item.name = 'ГП Выведение из экплуатаци АПР АП';
    item.ord = 9;
    dictionary.addItem(item);

    item = new DxNciDictionaryItem();
    item.id = 10;
    item.ident = 'PIT_GP_ASP_NG';
    item.name = 'ГП Внедрение АСП НГ';
    item.ord = 10;
    dictionary.addItem(item);

    return DxObjectMapper.toPlainJson(dictionary, DxNciDictionary);
  }


  public static provideEventsCustomersDictMocks(): Object {
    const dictionary = new DxNciDictionary();
    dictionary.id = 3;
    dictionary.ident = 'PIT_EVENT_CUSTOMER';
    dictionary.name = 'Справочник заказчиков ИТ-мероприятий';
    dictionary.isHierarchical = false;

    let item = new DxNciDictionaryItem();
    item.id = 1;
    item.name = 'Агентство по делам архивов';
    dictionary.addItem(item);

    item = new DxNciDictionaryItem();
    item.id = 2;
    item.name = 'Администрация губернатора Пермского края';
    dictionary.addItem(item);

    item = new DxNciDictionaryItem();
    item.id = 3;
    item.name = 'Аппарат Правительства Пермского края';
    dictionary.addItem(item);

    item = new DxNciDictionaryItem();
    item.id = 4;
    item.name = 'Государственная инспекция по экологии и природопользованию';
    dictionary.addItem(item);

    item = new DxNciDictionaryItem();
    item.id = 5;
    item.name = 'Инспекция государственного строительного надзора';
    dictionary.addItem(item);

    item = new DxNciDictionaryItem();
    item.id = 6;
    item.name = 'Инспекция государственного технического надзора';
    dictionary.addItem(item);

    item = new DxNciDictionaryItem();
    item.id = 7;
    item.name = 'Министерство образования и науки Пермского края';
    dictionary.addItem(item);

    item = new DxNciDictionaryItem();
    item.id = 8;
    item.name = 'Министерство природных ресурсов, лесного хозяйства и экологии';
    dictionary.addItem(item);

    item = new DxNciDictionaryItem();
    item.id = 9;
    item.name = 'Министерство промышленности, предпринимательства и торговли Пермского края';
    dictionary.addItem(item);

    item = new DxNciDictionaryItem();
    item.id = 10;
    item.name = 'Министерство социального развития Пермского края';
    dictionary.addItem(item);

    item = new DxNciDictionaryItem();
    item.id = 11;
    item.name = 'Министерство физической культуры и спорта Пермского края';
    dictionary.addItem(item);

    item = new DxNciDictionaryItem();
    item.id = 12;
    item.name = 'Министерство тарифного регулирования и энергетики Пермского края';
    dictionary.addItem(item);

    item = new DxNciDictionaryItem();
    item.id = 13;
    item.name = 'Министерство территориального развития Пермского края ';
    dictionary.addItem(item);

    item = new DxNciDictionaryItem();
    item.id = 14;
    item.name = 'Министерство жилищно-коммунального хозяйства и благоустройства Пермского края';
    dictionary.addItem(item);

    item = new DxNciDictionaryItem();
    item.id = 15;
    item.name = 'Министерство здравоохранения Пермского края';
    dictionary.addItem(item);

    item = new DxNciDictionaryItem();
    item.id = 16;
    item.name = 'Министерство информационного развития и связи Пермского края';
    dictionary.addItem(item);

    item = new DxNciDictionaryItem();
    item.id = 17;
    item.name = 'Министерство финансов Пермского края';
    dictionary.addItem(item);

    item = new DxNciDictionaryItem();
    item.id = 18;
    item.name = 'Министерство по управлению имуществом и земельным отношениям Пермского края';
    dictionary.addItem(item);

    item = new DxNciDictionaryItem();
    item.id = 19;
    item.name = 'Министерство строительства и архитектуры Пермского края';
    dictionary.addItem(item);

    item = new DxNciDictionaryItem();
    item.id = 20;
    item.name = 'Министерство территориальной безопасности Пермского края';
    dictionary.addItem(item);

    item = new DxNciDictionaryItem();
    item.id = 21;
    item.name = 'Министерство транспорта Пермского края';
    dictionary.addItem(item);

    item = new DxNciDictionaryItem();
    item.id = 22;
    item.name = 'Министерство экономического развития и инвестиций Пермского края';
    dictionary.addItem(item);

    item = new DxNciDictionaryItem();
    item.id = 23;
    item.name = 'Министерство по регулированию контрактной системы в сфере закупок Пермского края';
    dictionary.addItem(item);

    return DxObjectMapper.toPlainJson(dictionary, DxNciDictionary);
  }

  public static provideBudgetPeriodDictMocks(): Object {
    const dictionary = new DxNciDictionary();
    dictionary.id = 9;
    dictionary.ident = 'PIT_BUDGET_PERIODS';
    dictionary.name = 'Бюджетные периоды';
    dictionary.isHierarchical = false;

    let item = new DxNciDictionaryItem();
    item.id = 1;
    item.name = 'Бюджетный период 2019-2021 г.';
    item.parentId = 0;
    item.ord = 2019;
    dictionary.addItem(item);

    item = new DxNciDictionaryItem();
    item.id = 2;
    item.name = 'Бюджетный период 2020-2022 г.';
    item.parentId = 0;
    item.ord = 2020;
    dictionary.addItem(item);

    item = new DxNciDictionaryItem();
    item.id = 3;
    item.name = 'Бюджетный период 2020-2022 г.';
    item.parentId = 0;
    item.ord = 2021;
    dictionary.addItem(item);

    return DxObjectMapper.toPlainJson(dictionary, DxNciDictionary);
  }

  public static provideNciRegistryTreeMocks(): Object[] {
    const docNodes: PitNciRegistryTreeNode[] = [];

    let node: PitNciRegistryTreeNode = new PitNciRegistryTreeNode();
    node.id = 1;
    node.parentId = null;
    node.ord = 1;
    node.title = 'Справочники (общие)';
    node.ident = 'PIT_DICTIONARIES_MAIN';
    node.type = 'FOLDER';
    docNodes.push(node);

    node = new PitNciRegistryTreeNode();
    node.id = 2;
    node.parentId = 1;
    node.ord = 1;
    node.title = 'Блоки';
    node.ident = 'PIT_BLOCK_DICT';
    node.type = 'DICTIONARY';
    node.dictionaryIdent = 'block';
    docNodes.push(node);

    node = new PitNciRegistryTreeNode();
    node.id = 3;
    node.parentId = 1;
    node.ord = 2;
    node.title = 'Заказчики';
    node.ident = 'PIT_CONTRACTOR_DICT';
    node.type = 'DICTIONARY';
    node.dictionaryIdent = 'contractor';
    docNodes.push(node);

    node = new PitNciRegistryTreeNode();
    node.id = 4;
    node.parentId = 1;
    node.ord = 3;
    node.title = 'Уровни бюджета';
    node.ident = 'PIT_BUDGET_LEVEL_DICT';
    node.type = 'DICTIONARY';
    node.dictionaryIdent = 'budget-level';
    docNodes.push(node);

    node = new PitNciRegistryTreeNode();
    node.id = 5;
    node.parentId = 1;
    node.ord = 4;
    node.title = 'Бюдженые периоды';
    node.ident = 'PIT_BUDGET_PERIOD_DICT';
    node.type = 'DICTIONARY';
    node.dictionaryIdent = 'budget-period';
    docNodes.push(node);

    node = new PitNciRegistryTreeNode();
    node.id = 6;
    node.parentId = 1;
    node.ord = 5;
    node.title = 'Типы планов';
    node.ident = 'PIT_PLAN_TYPES_DICT';
    node.type = 'DICTIONARY';
    node.dictionaryIdent = 'plan-types';
    docNodes.push(node);

    node = new PitNciRegistryTreeNode();
    node.id = 7;
    node.parentId = 1;
    node.ord = 6;
    node.title = 'Типы закупочных инициатив';
    node.ident = 'PIT_PROCUREMENT_INITIATIVE_TYPE_DICT';
    node.type = 'DICTIONARY';
    node.dictionaryIdent = 'procurement-initiative-type';
    docNodes.push(node);

    node = new PitNciRegistryTreeNode();
    node.id = 8;
    node.parentId = 1;
    node.ord = 7;
    node.title = 'Государственные программы';
    node.ident = 'PIT_STATE_PROGRAM_DICT';
    node.type = 'DICTIONARY';
    node.dictionaryIdent = 'state-program';
    docNodes.push(node);

    node = new PitNciRegistryTreeNode();
    node.id = 9;
    node.parentId = 1;
    node.ord = 8;
    node.title = 'Показатели государственных программ';
    node.ident = 'PIT_STATE_PROGRAM_INDICATORS_DICT';
    node.type = 'DICTIONARY';
    node.dictionaryIdent = 'state-program-indicator';
    docNodes.push(node);

    node = new PitNciRegistryTreeNode();
    node.id = 10;
    node.parentId = 1;
    node.ord = 9;
    node.title = 'Уровни зрелости';
    node.ident = 'PIT_MATURITY_LEVELS_DICT';
    node.type = 'DICTIONARY';
    node.dictionaryIdent = 'maturity-levels';
    docNodes.push(node);

    node = new PitNciRegistryTreeNode();
    node.id = 11;
    node.parentId = 1;
    node.ord = 11;
    node.title = 'Статусы';
    node.ident = 'PIT_STATUS_DICT';
    node.type = 'DICTIONARY';
    node.dictionaryIdent = 'status';
    docNodes.push(node);

    node = new PitNciRegistryTreeNode();
    node.id = 12;
    node.parentId = 1;
    node.ord = 12;
    node.title = 'subject-area';
    node.ident = 'PIT_SUBJECT_AREA_DICT';
    node.type = 'DICTIONARY';
    node.dictionaryIdent = 'subject-area';
    docNodes.push(node);

    node = new PitNciRegistryTreeNode();
    node.id = 13;
    node.parentId = 1;
    node.ord = 13;
    node.title = 'target-consumption-item';
    node.ident = 'PIT_TARGET_CONSUMPTION_ITEM_DICT';
    node.type = 'DICTIONARY';
    node.dictionaryIdent = 'target-consumption-item';
    docNodes.push(node);

    node = new PitNciRegistryTreeNode();
    node.id = 14;
    node.parentId = 1;
    node.ord = 14;
    node.title = 'Пользователи';
    node.ident = 'PIT_USERS_DICT';
    node.type = 'DICTIONARY';
    node.dictionaryIdent = 'user';
    docNodes.push(node);

    node = new PitNciRegistryTreeNode();
    node.id = 15;
    node.parentId = 1;
    node.ord = 15;
    node.title = 'Типы работ';
    node.ident = 'PIT_WORK_TYPES_DICT';
    node.type = 'DICTIONARY';
    node.dictionaryIdent = 'work-type';
    docNodes.push(node);

    return DxObjectMapper.toPlainArray(docNodes, PitNciRegistryTreeNode);
  }

  public static provideContractStatuses(): Object {
    const dictionary = new DxNciDictionary();
    dictionary.id = 1;
    dictionary.ident = 'RIS_STATUS_CONTRACT';
    dictionary.name = 'Статусы контракта';
    dictionary.isHierarchical = false;

    let item: DxNciDictionaryItem;

    item = new DxNciDictionaryItem();
    item.id = 0;
    item.name = 'На рассмотрении';
    dictionary.addItem(item);

    item = new DxNciDictionaryItem();
    item.id = 1;
    item.name = 'Исполнение завершено';
    dictionary.addItem(item);

    item = new DxNciDictionaryItem();
    item.id = 2;
    item.name = 'Исполнение';
    dictionary.addItem(item);

    item = new DxNciDictionaryItem();
    item.id = 3;
    item.name = 'Ещё чуть-чуть и завершится';
    dictionary.addItem(item);

    return DxObjectMapper.toPlainJson(dictionary, DxNciDictionary);
  }

  public static provideContractors(): Object {
    const dictionary = new DxNciDictionary();
    dictionary.id = 1;
    dictionary.ident = 'CONTRACTORS';
    dictionary.name = 'Контрагенты контракта';
    dictionary.isHierarchical = false;

    let item: DxNciDictionaryItem;

    item = new DxNciDictionaryItem();
    item.id = 0;
    item.name = faker.company.companyName() + ' ' + faker.company.companySuffix();
    dictionary.addItem(item);

    item = new DxNciDictionaryItem();
    item.id = 1;
    item.name = 'Министерство информационного развития и связи Пермского края';
    dictionary.addItem(item);

    item = new DxNciDictionaryItem();
    item.id = 2;
    item.name = 'ООО "Исполнитель"';
    dictionary.addItem(item);

    item = new DxNciDictionaryItem();
    item.id = 3;
    item.name = faker.company.companyName() + ' ' + faker.company.companySuffix();
    dictionary.addItem(item);

    return DxObjectMapper.toPlainJson(dictionary, DxNciDictionary);
  }
}
